module.exports = __webpack_public_path__ + "static/media/Novosti3.acb3639c.png";